import { cn } from '@/shared/lib/cn'

const widths = {
  sm: 'max-w-3xl',
  default: 'max-w-7xl',
  lg: 'max-w-[88rem]',
  full: 'max-w-none',
} as const

interface ContainerProps {
  children: React.ReactNode
  className?: string
  size?: keyof typeof widths
}

/**
 * Page-width container. Locked sizes per §6.7.4.
 */
export function Container({ children, className, size = 'default' }: ContainerProps) {
  return (
    <div className={cn('mx-auto w-full px-4 sm:px-6 lg:px-8', widths[size], className)}>
      {children}
    </div>
  )
}
